const UF_LIST = [
  { value: "AC", text: "AC - ACRE" },
  { value: "AL", text: "AL - ALAGOAS" },
  { value: "AP", text: "AP - AMAPÁ" },
  { value: "AM", text: "AM - AMAZONAS" },
  { value: "BA", text: "BA - BAHIA" },
  { value: "CE", text: "CE - CEARÁ" },
  { value: "DF", text: "DF - DISTRITO FEDERAL" },
  { value: "ES", text: "ES - ESPÍRITO SANTO" },
  { value: "GO", text: "GO - GOIÁS" },
  { value: "MA", text: "MA - MARANHÃO" },
  { value: "MT", text: "MT - MATO GROSSO" },
  { value: "MS", text: "MS - MATO GROSSO DO SUL" },
  { value: "MG", text: "MG - MINAS GERAIS" },
  { value: "PA", text: "PA - PARÁ" },
  { value: "PB", text: "PB - PARAÍBA" },
  { value: "PR", text: "PR - PARANÁ" },
  { value: "PE", text: "PE - PERNAMBUCO" },
  { value: "PI", text: "PI - PIAUÍ" },
  { value: "RJ", text: "RJ - RIO DE JANEIRO" },
  { value: "RN", text: "RN - RIO GRANDE DO NORTE" },
  { value: "RS", text: "RS - RIO GRANDE DO SUL" },
  { value: "RO", text: "RO - RONDÔNIA" },
  { value: "RR", text: "RR - RORAIMA" },
  { value: "SC", text: "SC - SANTA CATARINA" },
  { value: "SP", text: "SP - SÃO PAULO" },
  { value: "SE", text: "SE - SERGIPE" },
  { value: "TO", text: "TO - TOCANTINS" },
];
const UF_REGIONS = [
  { value: "AC", description: "ACRE", region: "norte" },
  { value: "AL", description: "ALAGOAS", region: "nordeste" },
  { value: "AP", description: "AMAPÁ", region: "norte" },
  { value: "AM", description: "AMAZONAS", region: "norte" },
  { value: "BA", description: "BAHIA", region: "nordeste" },
  { value: "CE", description: "CEARÁ", region: "nordeste" },
  { value: "DF", description: "DISTRITO FEDERAL", region: "centro-oeste" },
  { value: "ES", description: "ESPÍRITO SANTO", region: "sudeste" },
  { value: "GO", description: "GOIÁS", region: "centro-oeste" },
  { value: "MA", description: "MARANHÃO", region: "nordeste" },
  { value: "MT", description: "MATO GROSSO", region: "centro-oeste" },
  { value: "MS", description: "MATO GROSSO DO SUL", region: "centro-oeste" },
  { value: "MG", description: "MINAS GERAIS", region: "sudeste" },
  { value: "PA", description: "PARÁ", region: "norte" },
  { value: "PB", description: "PARAÍBA", region: "nordeste" },
  { value: "PR", description: "PARANÁ", region: "sul" },
  { value: "PE", description: "PERNAMBUCO", region: "nordeste" },
  { value: "PI", description: "PIAUÍ", region: "nordeste" },
  { value: "RJ", description: "RIO DE JANEIRO", region: "sudeste" },
  { value: "RN", description: "RIO GRANDE DO NORTE", region: "nordeste" },
  { value: "RS", description: "RIO GRANDE DO SUL", region: "sul" },
  { value: "RO", description: "RONDÔNIA", region: "norte" },
  { value: "RR", description: "RORAIMA", region: "norte" },
  { value: "SC", description: "SANTA CATARINA", region: "sul" },
  { value: "SP", description: "SÃO PAULO", region: "sudeste" },
  { value: "SE", description: "SERGIPE", region: "nordeste" },
  { value: "TO", description: "TOCANTINS", region: "norte" },
];

const REGIONS = [
  {
    name: "centro-oeste",
    description: "Centro-Oeste",
  },
  {
    name: "nordeste",
    description: "Nordeste",
  },
  {
    name: "norte",
    description: "Norte",
  },
  {
    name: "sudeste",
    description: "Sudeste",
  },
  {
    name: "sul",
    description: "Sul",
  },
];

const TYPES_COMPANY = [
  { value: "fra", text: "FRANQUIA" },
  { value: "for", text: "FORNECEDOR" },
  { value: "mul", text: "MULTIMARCAS" },
];

const TYPES_USER = [
  {
    header: "Admistrador",
  },
  {
    value: "admin",
    text: "Franqueador",
  },
  {
    disabled: true,
    divider: true,
  },
  {
    header: "Empresas",
  },
  {
    value: "franchise",
    text: "Franqueado",
  },
  {
    value: "provider",
    text: "Fornecedor",
  },
  {
    disabled: true,
    divider: true,
  },
  {
    header: "Outros",
  },
  {
    value: "photo",
    text: "Fotografo",
  },
  {
    value: "royalties",
    text: "Faturamento Royalties",
  },
];

const USER_TYPES_DESCRIPTION = [
  {
    value: "admin",
    text: "Franqueador",
    color: "green",
  },
  {
    value: "franchise",
    text: "Franqueado",
    color: "blue",
  },
  {
    value: "provider",
    text: "Fornecedor",
    color: "brown",
  },
  {
    value: "photo",
    text: "Fotografo",
    color: "gray",
  },
  {
    value: "royalties",
    text: "Faturamento Royalties",
    color: "gray",
  },
  {
    value: "admin",
    text: "Franqueador",
    color: "green",
  },
];

export {
  UF_LIST,
  TYPES_COMPANY,
  UF_REGIONS,
  REGIONS,
  TYPES_USER,
  USER_TYPES_DESCRIPTION,
};
